export const FoodTruckScreen_EN_Trans = {
  title: "Caterer",
  noData: "No entries available",
  Company: "Food Truck",
  noMoreData: "No More Data",
  discoverMoreTruck:'Discover even more food trucks now',
  discoverMoreCaterer:'Discover even more caterers now'
};

export const FoodTruckScreen_DE_Trans = {
  title: "Caterer",
  noData: "Keine Einträge vorhanden",
  Company: "Food Truck",
  noMoreData: "Keine weiteren Daten",
  discoverMoreCaterer:'Jetzt noch mehr Caterers entdecken',
  discoverMoreTruck:'Jetzt noch mehr foodtrucks entdecken'
};

